import api from '@api/api';
import { Email } from '@customTypes/Entities';
import useFetchAll from '@hooks/useFetchAll';

const useEmails = (date?: string) => {
  const { data, isFetching, error, ...rest } = useFetchAll<Email>({
    queryKeyRoot: 'emails',
    apiFn: (params) => api.getEmails(params),
    date,
  });

  return { emails: data, isFetching, error, ...rest };
};

export default useEmails;
